import { ReactNode } from 'react';

import { Box, BoxProps } from '../Box/Box';

type Align = 'left' | 'center' | 'right';

interface StackProps extends Pick<BoxProps, 'gap' | 'id'> {
  align?: Align;
  children: ReactNode;
}

const resolveAlign: { [key in Align]: BoxProps['alignItems'] } = {
  left: 'flexStart',
  center: 'center',
  right: 'flexEnd',
};

export const Stack: React.FC<React.PropsWithChildren<StackProps>> = ({ gap = 'none', children, align }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems={align ? resolveAlign[align] : undefined} gap={gap}>
      {children}
    </Box>
  );
};
